import { useQuery } from '@apollo/client/react';
import { useEffect } from 'react';
import { client } from '@guuru/graphql-web';
import i18n from '@guuru/translation-common';
import GET_TRANSLATIONS from './queries/GetPersistedTranslations';

const setTranslations = (language, translations) => {
  const { expertAlias, communityAlias, gptBotAlias } = translations?.chat || {};
  if (expertAlias || communityAlias) {
    i18n.options.interpolation.defaultVariables = {
      expertAlias,
      communityAlias,
      gptBotAlias,
    };
  }
  Object.keys(translations).forEach((ns) => {
    i18n.addResourceBundle(language, ns, translations[ns]);
  });
};

const loadTranslations = async (locale, namespaces, partnerId) => {
  const {
    data: { translations },
  } = await client.query({
    query: GET_TRANSLATIONS,
    variables: {
      id: partnerId,
      locale,
      namespaces,
    },
  });
  namespaces.forEach((ns) => {
    i18n.addResourceBundle(locale, ns, translations[ns]);
  });
};

const useLoadTranslations = (locale, namespaces, partnerId) => {
  const { data } = useQuery(GET_TRANSLATIONS, {
    variables: {
      id: partnerId,
      locale,
      namespaces,
    },
  });

  useEffect(() => {
    const translations = data?.translations;
    if (!translations) return;

    namespaces.forEach((ns) => {
      i18n.addResourceBundle(locale, ns, translations[ns]);
    });
  }, [data?.translations, locale, namespaces]);
};

export { setTranslations, loadTranslations, useLoadTranslations };
